const LoadedStory = (props) => {
    const responseObj = props.responseObj;
    const usernames = ["hannanmax_", "hannan_max", "nilen.patel", "dhamku_16", "rawal.kish","_.aditi.2","__shelinaaa"];
    console.log("Loaded Response: ",responseObj);
    // If no such account found
    if (responseObj.message) {
        return (
            <div className="error-page">
                <h1>No such account found !</h1>
                <p>{responseObj.message}</p>
            </div>
        );
    }
    //console.log(responseObj, "From loaded");
    const storyArray = responseObj.story.data;
    //console.log("storydata:" + storyArray);

    // If account exists but no story uploaded
    if (!storyArray.length) {
        return (
            <>
                <header className="user-info">
                    <img
                        src={responseObj.profile_pic_url}
                        className="profile-picture"
                        alt="Profile"
                    />
                    <div className="right-section">
                        <h3>{responseObj.username}</h3>
                        <p>{responseObj.full_name}</p>
                    </div>
                </header>
                <div className="error-page">
                    <h1>No story found !</h1>
                    <p>User has not uploaded any story !</p>
                </div>
            </>
        );
    }

    // If owners account
    var edtUsername = "" + JSON.stringify(responseObj.username);
    if (JSON.stringify(usernames).includes(edtUsername)) {
        return (
            <>
                <header className="user-info">
                    <img
                        src={responseObj.profile_pic_url}
                        className="profile-picture"
                        alt="Profile"
                    />
                    <div className="right-section">
                        <h3>{responseObj.username}</h3>
                        <p>{responseObj.full_name}</p>
                    </div>
                </header>
                <div className="error-page">
                    <h1>Are you serious?</h1>
                    <p>You can't spy on owner @hannan_max or his buddies Pal😂😂😂</p>
                </div>
            </>
        );
    }
    
    // When User found and story is uploaded
    return (
        <>
            <header className="user-info">
                <img
                    src={responseObj.profile_pic_url || '#'}
                    className="profile-picture"
                    alt="Profile"
                />
                <div className="right-section">
                    <h3>{responseObj.username}</h3>
                    <p>{responseObj.full_name}</p>
                </div>
            </header>
            <section className="story-list">
                {storyArray.map((element, index) => {
                    //StoryData
                    var poll = "";
                    var pollPositiveName = "";
                    var pollPositiveCount = 0;
                    var pollNegativeName = "";
                    var pollNegativeCount = 0;
                    if(typeof element.story_polls != "undefined"){
                        pollPositiveName = element.story_polls[0].poll_sticker.tallies[0].text;
                        pollPositiveCount = element.story_polls[0].poll_sticker.tallies[0].count;
                        pollNegativeName = element.story_polls[0].poll_sticker.tallies[1].text;
                        pollNegativeCount = element.story_polls[0].poll_sticker.tallies[1].count;
                        poll = "\nPoll: " + pollPositiveName + " [Count: " + pollPositiveCount + "] " + pollNegativeName + " [Count: " + pollNegativeCount + "] ";
                    }
                    var story_quizs_answer = "";
                    if(typeof element.story_quizs != "undefined"){
                        story_quizs_answer = "\nQuiz Answer: " + element.story_quizs[0].quiz_sticker.tallies[element.story_quizs[0].quiz_sticker.correct_answer].text;
                    }

                    if (element.media_type === 2) {
                        if(typeof element.reel_mentions != "undefined"){
                            var mentions = "";
                            var count = 0;
                            var edtUsername = "" + JSON.stringify(responseObj.username);
                            if(JSON.stringify(usernames).includes(edtUsername)){
                                mentions = "You don't spy on owners Pal😂😂😂";
                            } else {
                                for(var i = 0;i<element.reel_mentions.length;i++){
                                    mentions = mentions + "@" + element.reel_mentions[i].user.username + " ";
                                    count++;
                                }
                            }
                            return (
                                <div className="story-item" key={index}>
                                <center>
                                    <button className="submitBtn"><a href={"https://www.instagram.com/p/" + element.code}>Story to Post</a></button>
                                    <br></br>
                                    <a className="downloadBtn" href={element.video_versions[0].url+"==.mp4"} download={responseObj.full_name +".mp4"}>
                                        <button className="downloadBtn"><i className="fa fa-download"></i> Download Story </button>
                                    </a>
                                    <br></br>
                                    <p>Story Mentions: {count}</p>
                                    <p>{mentions}</p>
                                    <p>{poll}</p>
                                    <p>{story_quizs_answer}</p>
                                    <br></br>
                                </center>
                                <video className="story-item" key={index} controls>
                                    <source
                                        src={element.video_versions[0].url}
                                        className="story-media"
                                        type="video/webm"
                                    ></source>
                                </video>
                            </div>
                            );
                        } else {
                            var mentions2 = "";
                            var edtUsername2 = "" + JSON.stringify(responseObj.username);
                            if(JSON.stringify(usernames).includes(edtUsername2)){
                                mentions2 = "You don't spy on owners Pal😂😂😂";
                            }
                            return (
                                <div className="story-item" key={index}>
                                <center >
                                    <button className="submitBtn"><a href={"https://www.instagram.com/p/" + element.code}>Story to Post</a></button>
                                    <br></br>
                                    <a className="downloadBtn" href={element.video_versions[0].url+"==.mp4"} download={responseObj.full_name + ".mp4"}>
                                        <button className="downloadBtn"><i className="fa fa-download"></i> Download Story </button>
                                    </a>
                                    <br></br>
                                    <p>{mentions2}</p>
                                    <p>{poll}</p>
                                    <p>{story_quizs_answer}</p>
                                    <br></br>
                                </center>
                                <video className="story-item" key={index} controls>
                                    <source
                                        src={element.video_versions[0].url}
                                        className="story-media"
                                        type="video/webm"
                                    ></source>
                                </video>
                            </div>
                            );
                        }
                    } else {
                        if(typeof element.reel_mentions != "undefined"){
                            var mentions3 = "";
                            count = 0;
                            var edtUsername3 = "" + JSON.stringify(responseObj.username);
                            if(JSON.stringify(usernames).includes(edtUsername3)){
                                mentions3 = "You don't spy on owners Pal😂😂😂";
                            } else {
                                for(var i2 = 0;i2<element.reel_mentions.length;i2++){
                                    mentions3 = mentions3 + "@" + element.reel_mentions[i2].user.username + " ";
                                    count++;
                                }
                            }
                            return (
                                <div className="story-item" key={index}>
                                    <center>
                                        <button className="submitBtn"><a href={"https://www.instagram.com/p/" + element.code}>Story to Post</a></button>
                                        <br></br>
                                        <a className="downloadBtn" href={element.image_versions2.candidates[0].url+"==.jpg"} download={responseObj.full_name + ".jpg"}>
                                            <button className="downloadBtn"><i className="fa fa-download"></i> Download Story </button>
                                        </a>
                                        <br></br>
                                        <p>Story Mentions: {count}</p>
                                        <p>{mentions3}</p>
                                        <p>{poll}</p>
                                        <p>{story_quizs_answer}</p>
                                        <br></br>
                                    </center>
                                    <img
                                        src={element.image_versions2.candidates[0].url}
                                        className="story-media"
                                        alt={element.code}
                                    />
                                </div>
                            );
                        } else {
                            var mentions4 = "";
                            var edtUsername4 = "" + JSON.stringify(responseObj.username);
                            if(JSON.stringify(usernames).includes(edtUsername4)){
                                mentions4 = "You don't spy on owners Pal😂😂😂";
                            }
                            return (
                                <div className="story-item" key={index}>
                                    <center>
                                        <button className="submitBtn"><a href={"https://www.instagram.com/p/" + element.code}>Story to Post</a></button>
                                        <br></br>
                                        <a className="downloadBtn" href={element.image_versions2.candidates[0].url+"==.jpg"} download={responseObj.full_name + ".jpg"}>
                                            <button className="submitBtn"><i className="fa fa-download"></i> Download Story </button>
                                        </a>
                                        <br></br>
                                        <p>{mentions4}</p>
                                        <p>{poll}</p>
                                        <p>{story_quizs_answer}</p>
                                        <br></br>
                                    </center>
                                    <img
                                        src={element.image_versions2.candidates[0].url}
                                        className="story-media"
                                        alt={element.code}
                                    />
                                </div>
                            );
                        }
                    }
                })}
            </section>
        </>
    );
};

export default LoadedStory;
